<template>
    <div class="anjian">
        <div v-wechat-title="$route.meta.title"></div>
        <Card class='card-left'>
            <Menu mode="vertical" theme="light" :active-name="menuName" :open-names="openNames" @on-select='menuItem'>
                <Submenu :name="item.key" v-for="(item,index) in userInfo.menuList.runSet.children" :key="index">
                    <template slot="title">
                        <img :src="iconList[index]" class="menuIcon"/>
                        <span style="font-weight: bold;">{{item.name}}</span>
                    </template>
                    <MenuItem v-for="(menuItem,menuIndex) in item.children" :key="menuIndex" :name="menuItem.key">
                        {{menuItem.name}}
                    </MenuItem>
                </Submenu>
            </Menu>
        </Card>
        <div class='card-right-top'>
            <AdminSet v-if="menuName == 'admin_set_all' "></AdminSet>
            <information v-if="menuName == 'information_set_all' "></information>
            <materialManage v-if="menuName == 'img_material_manage' "></materialManage>
            <feedbackManage v-if="menuName == 'user_feedback_manage' "></feedbackManage>
            <MediaPlatform v-if="menuName == 'media_platform' "></MediaPlatform>
            <MediaPlatformWithdraw v-if="menuName == 'media_platform_withdraw' "></MediaPlatformWithdraw>
            <MediaCode v-if="menuName == 'media_code' "></MediaCode>
            <BrandManage v-if="menuName == 'brand_manage' "></BrandManage>
            <JuniorManage v-if="menuName == 'junior_manage' "></JuniorManage>
            <JuniorRecharge v-if="menuName == 'junior_recharge' "></JuniorRecharge>
            <Card v-if="menuName == 'media_statistics' ">
                <MediaStatistics></MediaStatistics>
            </Card>
            <Card v-if="menuName == 'channel_statistics' ">
                <ChannelStatistics></ChannelStatistics>
            </Card>
            <Card v-if="menuName == 'client_statistics' ">
                <ClientStatistics></ClientStatistics>
            </Card>
            <TrendAnalysis v-if="menuName == 'trend_analysis' "></TrendAnalysis>
            <DetailList v-if="menuName == 'detail_list' "></DetailList>
            <AdvertisingCost v-if="menuName == 'advertising_cost' "></AdvertisingCost>
            <CostSet v-if="menuName == 'cost_set' "></CostSet>
            <CostCollect v-if="menuName == 'cost_collect' "></CostCollect>
			<AdvertisingManage v-if="menuName == 'advertingManage' "></AdvertisingManage>
        </div>
    </div>
</template>

<script>
    import MediaPlatform from './MediaPlatform.vue'
    import MediaCode from './MediaCode.vue'
    import MediaPlatformWithdraw from './MediaPlatformWithdraw.vue'
    import BrandManage from './BrandManage.vue'
    import JuniorManage from './JuniorManage.vue'
    import JuniorRecharge from './JuniorRecharge.vue'
    import MediaStatistics from './MediaStatistics.vue'
    import ChannelStatistics from './ChannelStatistics'
    import ClientStatistics from './ClientStatistics.vue'
    import TrendAnalysis from './TrendAnalysis.vue'
    import DetailList from './DetailList.vue'
    import AdvertisingCost from './AdvertisingCost.vue'
	import AdvertisingManage from './AdvertisingManage.vue'
    import CostSet from './CostSet.vue'
    import CostCollect from './CostCollect.vue'
    import {mapGetters} from "vuex";
    import AdminSet from "../admin/adminSet";
    import Information from "../admin/information";
    import materialManage from "./materialManage";
    import feedbackManage from "./feedbackManage";

    export default {
        name: "RunSet",
        components: {
            Information,
            materialManage,
            feedbackManage,
            MediaPlatformWithdraw,
            AdminSet,
            MediaPlatform,
            MediaCode,
            BrandManage,
            JuniorManage,
            JuniorRecharge,
            MediaStatistics,
            ChannelStatistics,
			AdvertisingManage,
            ClientStatistics,
            TrendAnalysis,
            DetailList,
            AdvertisingCost,
            CostSet,
            CostCollect
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        created() {
            // 初始化菜单图标
            this.initIcon();
        },
        mounted() {
            var children = this.userInfo.menuList.runSet.children;
            this.openNames = [children[0].key];
            this.menuName = children[0].children[0].key;
        },
        data() {
            return {
                menuName: 'admin_set_all',
                openNames: ['admin_set'],
                iconList: []
            }
        },
        methods: {
            initIcon() {
                let that = this
                this.userInfo.menuList.runSet.children.forEach(function (row, index) {
                    that.iconList[index] = require('../../assets/icons/runSet/'+row.key+'.png');
                })
            },
            menuItem(e) {
                this.menuName = e;
            },
        }

    }
</script>

<style scoped lang="less">
    .card-right-top {
        min-width: 1350px;
    }
    .menuIcon{
        display: inline-block;
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-bottom: 3px;
        margin-right: 5px;
    }
</style>